export function dataInRequest(params = {}) {
  return {
    type: '@manutencaoDvec/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@manutencaoDvec/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@manutencaoDvec/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@manutencaoDvec/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@manutencaoDvec/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@manutencaoDvec/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@manutencaoDvec/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@manutencaoDvec/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@manutencaoDvec/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@manutencaoDvec/RECORD_FILTERING',
    payload: { params },
  };
}
